import React from 'react'
import Wizard from '../../mailTemplate/src/components/atomic/pages/Wizard'
import CampaignPreparation from '../../mailTemplate/src/components/atomic/pages/CampaignPreparation'
import CampaignReview from '../../mailTemplate/src/components/atomic/pages/CampaignReview'

const CampaignFirms = ({ campaign, onCampaignUpdate }) => {
  const status = campaign?.status

  if (status === 'PREPARING' || status === 'READY_TO_SELECT') {
    return (
      <CampaignPreparation
        campaign={campaign}
        onCampaignUpdate={onCampaignUpdate}
        showProgressBar={status === 'PREPARING'}
      />
    )
  }

  if (status === 'GENERATING' || status === 'READY_TO_MAIL' || status === 'MAILING') {
    return (
      <CampaignReview
        campaign={campaign}
        onCampaignUpdate={onCampaignUpdate}
        showProgressBar={status === 'GENERATING'}
      />
    )
  }

  return <Wizard onCampaignUpdate={onCampaignUpdate} />
}

export default CampaignFirms
